import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { venturaConfig } from "./data";

export default function VenturaPage() {
  return <CityPageTemplate config={venturaConfig} />;
}